/*
 *   File : reject.js
 *   Author : https://evoqins.com
 *   Description : Request rejection modal
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

//Custom component
import { TextArea } from '../FormElements';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';

const RejectModal = (props) => {

    const [message, setMessage] = useState("");
    const [messageError, setMessageError] = useState("");

    useEffect(() => {
        if (props.status === true) {
            _handleCloseRejectModal();
        }

    }, [props.status]);

    //handle modal close
    const _handleCloseRejectModal = () => {
        var button = document.getElementById("reject-modal-close");
        button.click();
        props.handleClose();
        setMessage("");
    };

    //handle modal close
    const _handleReject = () => {
        let data = {
            id: props.id,
            message: message
        }

        props.handleReject(data);
    };


    return (
        <div className="modal fade" id="reject-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="requestRejectModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered e-border-radius-24 modal-lg modal-dialog-scrollable">
                <div className="modal-content e-border-radius-8 p-4">
                    <button type="button"
                        id='reject-modal-close'
                        className="btn-close shadow-none d-none"
                        data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="modal-header px-0 pt-0 pb-3 border-0 align-items-start">
                        <div>
                            <h4 className="mb-2 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px">
                                {props.title}
                            </h4>
                            <p className='mb-0 e-alt-font-noto-sans e-text-davys-grey e-font-14 e-font-weight-400 line-height-20px'>
                                Review missing items and confirm to complete the upload.
                            </p>
                        </div>
                        <Icon icon="close-icon"
                            className='cursor-pointer'
                            size="24px"
                            onPress={_handleCloseRejectModal} />
                    </div>
                    <div className="modal-body px-0 pb-4 pt-2">

                        <div className='row gx-3 row-gap-2 w-100'>
                            <div className='col-4'>
                                <div className=''>
                                    {(() => {
                                        const url = props.fileUrl?.split('?')[0];
                                        const fileExtension = url?.split('.').pop()?.toLowerCase();
                                        const isImage = ['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension);
                                        const isPDF = fileExtension === 'pdf';

                                        if (!props.fileUrl) {
                                            return <span className='e-text-raisin-black e-alt-font-noto-sans e-font-14'>No bill available</span>;
                                        }
                                        if (isPDF) {
                                            return (
                                                <div className='d-flex flex-column gap-3 '>
                                                    <p className='mb-0 e-alt-font-noto-sans e-font-14 line-height-20px e-text-rich-black e-font-weight-500'>
                                                        {props.fileUrl?.split('/').pop() || props.fileUrl}
                                                    </p>
                                                    <SecondaryButton
                                                        name={<><Icon icon="download-icon" className="me-1" size={20} /> Download</>}
                                                        className="e-text-indigo e-border-1px-indigo align-self-start"
                                                        padding="py-2 px-3"
                                                        onPress={() => {
                                                            const link = document.createElement('a');
                                                            link.href = props.fileUrl;
                                                            link.download = "invoice";
                                                            document.body.appendChild(link);
                                                            link.click();
                                                            document.body.removeChild(link);
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (isImage) {
                                            return (
                                                <img
                                                    src={props.fileUrl}
                                                    height={360}
                                                    className='e-border-1px-chinese-silver w-100 cursor-pointer'
                                                    alt='invoice'
                                                />
                                            );
                                        }
                                        return (
                                            <img src={props.fileUrl}
                                                height={360}
                                                className='e-border-1px-chinese-silver w-100'
                                                alt='invoice' />
                                        );
                                    })()}
                                </div>
                            </div>
                            <div className='col-8 pe-0'>
                                <div className='d-flex flex-column h-100 justify-content-between gap-4'>
                                    <div className='e-bg-beautiful-white e-border-radius-16 p-4'>
                                        <TextArea label="Enter reason"
                                            placeholder="Enter your text"
                                            type="text"
                                            rows={7}
                                            value={message}
                                            error={messageError}
                                            className="w-100 px-3 padding-12px-tb"
                                            handleChange={(e) => setMessage(e)} />
                                    </div>

                                    <div className='row w-100 m-0 gx-3'>
                                        <div className='col-6 ps-0'>
                                            <SecondaryButton name="Cancel"
                                                className="e-border-radius-8 w-100"
                                                onPress={_handleCloseRejectModal} />
                                        </div>
                                        <div className='col-6 pe-0'>
                                            <PrimaryButton name="Reject"
                                                className="e-border-radius-8 w-100"
                                                status={props.loader}
                                                onPress={_handleReject} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(RejectModal);